import styled from 'styled-components';

export const CardHeaderRightTextSC = styled.span`
  margin-left: 12px;
  color: ${({ theme }) => theme.color.tint.tertiary};
  ${({ theme }) => theme.mappedTypography.captionSmall.default};
`;
